import PageWrapDefault from "./page-wrap-default";

export default PageWrapDefault;